
<form [ngClass]="{ readonly: ReadOnly == true }" class="disposition-tab" style="padding: 0.625rem" *ngIf="conf.Groups.length > 0;else hideDivAndRemoveWhiteSpace">
  <!-- <div class="heading">Once the call is complete, choose an appropriate outcome: <span class="star">*</span></div> -->
  <ng-container *ngFor="let group of conf.Groups">
     <div class="labelHead">
      {{ group.GroupDescription }}
    <hr *ngIf="anyFieldVisible(group)" class="hrRow" style="margin-bottom: 0.625rem;">
    <ng-container class="field" *ngFor="let field of group.Fields">
      <div *ngIf="field.fieldType === 'CheckBoxGroupWithOther' && field.show">
        <div *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'; let i = index">
          <div class="row">
            <div class="col-12" style="padding-top: 0.625rem">
              <input
                class="form-check-input checkbox"
                type="radio"
                [name]="field.Name"
                [id]="option + '-' + option.FieldOptionID"
                [value]="option.Value"
                (click)="onDispositionTypeChange(group, field, $event)"
                [disabled]="field.isDisabled"
                [checked]="field.value == option.Value"
              />
              <label class="form-check-label checkbox-label" for="option-{{option.FieldOptionID}}">
                {{ option.Name }}
              </label>
            </div>
            <!-- Dependent field, find field that matches current filed's option.Name -->
            <div class="col-12">
              <div *ngFor="let fieldInner of group.Fields">
                <ng-container *ngIf="option.Name == fieldInner.Name || option.Name.includes(fieldInner.Name)">
                <select
                  style="
                  border: none;
                  width: 13rem;
                  border-radius: 0.063rem;
                  border-bottom: 1.4px solid #2f78c4;
                  color: #53565a;
                  font-size: 0.938rem;
                  margin-left: 1.7rem;
                  margin-top: 0.4rem;"
                [name]="fieldInner.Name"
                [id]="fieldInner.fieldID"
                [ngModel]="getModel(group, fieldInner)"
                (change)="onFormDataChange(group, fieldInner, $event, null)"
                [disabled]="field.value != option.Value"
              >
                <option
                  *ngFor="let subOption of fieldInner.fieldOptions | orderBy: 'DisplayOrder'"
                  value="{{ subOption.Value }}"
                >
                  {{ subOption.Name }}
                </option>
                </select>
                <div *ngIf="field.value == option.Value && fieldInner.isRequired && !fieldInner.value" style="margin-left: 1.6rem;"><span class="star">This field is required</span></div>
                </ng-container>
              </div>
             
            </div>
          </div>
        </div>
      </div>

      <div class="input-data" *ngIf="field.fieldType === 'DropDown' && field.show">
        <label for="{{ field.Name }}">{{ field.Label }}</label>
        <span class="star" *ngIf="field.isRequired"> *</span>
        <select [ngModel]="getModel(group, field)" [name]="field.Name" [id]="field.fieldID"
          [required]="field.isRequired" [disabled]="field.isDisabled" (change)="onDropDownChange(group, field, $event, null)">
          <option value="">Select One</option>
          <option *ngFor="let option of field.fieldOptions | orderBy: 'DisplayOrder'" value="{{ option.Value }}">
            {{ option.Name }}
          </option>
        </select>
        <!-- <div class="underline-fixed"></div> -->
        <div class="text-danger" *ngIf="field.invalid">
          <small *ngIf="field.isRequiredError">{{ field.Label }} is required</small>
          <small *ngIf="field.patternError">Invalid {{ field.Label }}</small>
          <small *ngIf="field.minLengthError">
            {{ field.Label }} must be at least {{ field.minLength }} characters
          </small>
          <small *ngIf="field.maxLengthError">
            {{ field.Label }} must be at most {{ field.maxLength }} characters</small>
        </div>
      </div>

      <div class="input-data" *ngIf="field.fieldType === 'CheckBox' && field.show" >
        <div class="row">
          <div class="col-4" style="min-height: 4rem;padding-top: 23px;">
            <div class="form-check">
              <input
              class="form-check-input checkbox"
              type="checkbox"
              [value]="getModel(group, field)"
              [disabled]="field.isDisabled"
              (change)="onCheckBoxChange(group, field, $event)"
              [checked]="field.isSelected"
              [id]="field.fieldID"
            />
            <label class="checkbox-label form-check-label-1" for="{{field.fieldID}}">
              {{ field.Label }}
            </label>
            </div>
          </div>

          <div class="col-8">
            <ng-container *ngFor="let groupInner of conf.Groups">
              <ng-container class="field" *ngFor="let fieldInner of groupInner.Fields">
                <div class="input-data" *ngIf="fieldInner.fieldType === 'MultiSelect' && isParent(field, fieldInner) && field.isSelected && field.show">
                  <!-- <select
                  style="
                  border: none;
                  width: 13rem;
                  border-radius: 0.063rem;
                  border-bottom: 1.4px solid #2f78c4;
                  color: #53565a;
                  font-size: 0.938rem;
                  margin-top: 1rem;
                "
                [name]="fieldInner.Name"
                [id]="fieldInner.fieldID"
                [ngModel]="getModel(group, fieldInner)"
                (change)="onFormDataChange(group, fieldInner, $event, null)"
                
              >
                <option
                  *ngFor="let subOption of fieldInner.fieldOptions | orderBy: 'DisplayOrder'"
                  value="{{ subOption.Value }}"
                >
                  {{ subOption.Name }}
                </option>
                </select> -->
          
                <div class="multiselect-dropdown">
                  <input type="checkbox" id="dropdown-toggle" class="dropdown-toggle">
                  <label for="dropdown-toggle" class="dropdown-label" (click)="toggleDropdown($event)"><span *ngIf="fieldInner.value.length > 0">{{fieldInner.csv}}</span> <span *ngIf="fieldInner.value.length == 0">Select Options</span></label>
                  <div class="dropdown-options" *ngIf="dropdownOpen">
                    <label class="ms" *ngFor="let option of fieldInner.fieldOptions">
                      <input class="form-check-input checkbox" type="checkbox" [checked]="fieldInner.value.includes(option.Value)" [value]="option.Value" (change)="onFormDataChange(group, fieldInner, $event, null);"> {{ option.Name }}
                    </label>
                  </div>
                  <div *ngIf="fieldInner.isRequired && fieldInner.value.length==0"><span class="star">This field is required</span></div>
                </div>

                </div>
                <div class="input-data" *ngIf="fieldInner.fieldType === 'DateTimePicker' && isParent(field, fieldInner) && field.isSelected">
                    <div class="col-6">
                      <div class="form-group">
                        <label class="form-label follow-label" for="{{fieldInner.Name}}"> {{ fieldInner.Label }} </label>
                        <span class="star"> *</span>
                        <!-- <input *ngIf="false"
                          class="todate form-control"
                          [value]="getModel(group, fieldInner)"
                          (change)="onFormDataChange(group, fieldInner, $event, null)"
                          type="date"
                          [name]="fieldInner.Name"
                          [disabled]="field.isDisabled"
                        />
                        
                        <p-calendar 
                          inputId="calendar-24h" 
                          class="todate form-control"
                          [value]="getModel(group, fieldInner)"
                          [(ngModel)]="field.value"
                          [showTime]="true" 
                          hourFormat='24'
                          [showIcon]="true" 
                          [name]="fieldInner.Name"
                          [readonlyInput]="true"
                          (onSelect)="calSelectedDate(group, fieldInner, $event, null)"
                          (onChange)="onFormDataChange(group, fieldInner, $event, null)"
                          [disabled]="field.isDisabled" /> -->
                          <app-calendar-with-timezone
                          [defaultDate]="getDateTimePickerModel(fieldInner)"
                          [showTime] = "true"
                          [hourFormat]= "12"
                          [displayTimeZone] = "true"
                          [parentWidth] = "'261px'"
                          [disabled]="field.isDisabled"
                          (dateSelected)="onCalendarDateSelected(group, fieldInner, $event)"
                        ></app-calendar-with-timezone> 
                        <!-- <input type="text" value="" style="padding-bottom: 0.5rem" #input />
                        <div class="underline-fixed"></div> -->
                        <div class="underline-fixed" style="min-width: 22.5%;border-bottom: 1.4px solid #2F78C3;"></div>
                      </div>
                    </div>
                </div>
              </ng-container>
            </ng-container>
          </div>

        </div>
      </div>

      <!-- DateTimePicker -->
      <div class="input-data date-picker" *ngIf="field.fieldType === 'DateTimePicker' && !field.parent && field.show">
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label class="form-label follow-label" for="toDate"> {{ field.Label }} </label>
              <span class="star"> *</span>
              <!-- <input
                class="todate form-control"
                [value]="dispositionPayload.FollowUpDateTime"
                (change)="onFormDataChange(group, field, $event, null)"
                type="date"
                name="toDate"
                [disabled]="field.isDisabled"
              /> -->
              <app-calendar-with-timezone
              [defaultDate]="dispositionPayload.FollowUpDateTime"
              [showTime] = "true"
              [hourFormat]= "12"
              [disabled]="field.isDisabled"
              [displayTimeZone] = "true"
              [parentWidth] = "'261px'"
              (dateSelected)="onCalendarDateSelected(group, field, $event)"
            ></app-calendar-with-timezone> 
              <!-- <input type="text" value="" style="padding-bottom: 0.5rem" #input />
              <div class="underline-fixed"></div> -->
            </div>
          </div>
        </div>
      </div>
     
      <ng-container>
        <div class="input-data" *ngIf="field.fieldType === 'TextArea' && !field.isEmail && field.show" style="width: 10rem">
          <!-- <div class="heading mt-10">Notes</div> -->
          <label for="{{ field.Name }}" class="mt-10">{{ field.Label }}</label>
          <textarea class="form-control" 
          [id]="field.fieldID" 
          [name]="field.Name"
          [value]="field.value" 
          (change)="onFormDataChange(group, field, $event, null)"></textarea>
        </div>
      </ng-container>
    </ng-container>
  </div> 
  </ng-container>
</form>
<ng-template #hideDivAndRemoveWhiteSpace>
  <div class="hide-div"></div>
</ng-template>